import Timeseries from "../../components/generic-components/charts/timeseries/Timeseries"
import Pie from "../../components/generic-components/charts/pie/Pie"
import Bar from "../../components/generic-components/charts/bar/Bar"

export default {
  timeseries: Timeseries,
  pie: Pie,
  bar: Bar
}